<div class="chatbot"
     data-testid="chatbot"
     container='body'
     (click)="open()"
     ngbTooltip="{{'TOOLTIP.CHATBOT' | translate}}">
  <img [src]="'assets/images/chatbot.png'" alt="ChatBot">
</div>


<ng-template #chatbotDialog>

  <div class="modal-header" style="padding: 0 20px">
    <div class="h4 modal-title">{{ "TITLE.CHATBOT" | translate }}</div>

    <pt-icon class="cursor-pointer ms-auto expand-btn"
             [size]="24"
             [key]="expand ? reduceIcon : expandIcon"
             (click)="toggleExpandDialog()"></pt-icon>

    <button type="button" class="btn-close close ms-0" aria-label="Close" (click)="close()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="cmessage-container">
      <ng-container *ngFor="let msg of messages">
        <ng-container [ngSwitch]='msg.messageType'>

          <pt-chatbot-generic-message
            *ngSwitchCase="MT.ChatbotGenericMessage"
            [msg]="msg">
          </pt-chatbot-generic-message>

<!--          <gfmi-chatbot-ask-question-request-->
<!--            *ngSwitchCase="MT.ChatbotAskQuestionRequest"-->
<!--            [msg]="msg">-->
<!--          </gfmi-chatbot-ask-question-request>-->

<!--          <gfmi-chatbot-ask-question-response-->
<!--            *ngSwitchCase="MT.ChatbotAskQuestionResponse"-->
<!--            [msg]="msg"-->
<!--            (sentReaction)="sentReaction($event, msg.payload)"-->
<!--            (sentSectionReaction)="sentSectionReaction($event, msg.payload)"-->
<!--          >-->
<!--          </gfmi-chatbot-ask-question-response>-->

<!--          <gfmi-chatbot-send-reaction-request-->
<!--            *ngSwitchCase="MT.ChatbotSendReactionRequest"-->
<!--            [msg]="msg">-->
<!--          </gfmi-chatbot-send-reaction-request>-->

<!--          <gfmi-chatbot-send-section-reaction-request-->
<!--            *ngSwitchCase="MT.ChatbotSendSectionReactionRequest"-->
<!--            [msg]="msg">-->
<!--          </gfmi-chatbot-send-section-reaction-request>-->

<!--          <gfmi-chatbot-message-->
<!--            *ngSwitchCase="MT.Chatbot"-->
<!--            [msg]="msg">-->
<!--          </gfmi-chatbot-message>-->

        </ng-container>
      </ng-container>

      <div *ngIf="loading" class='spinner-border spinner-border-sm d-flex' style="margin:0 auto"></div>

    </div>
    <div class="cmessage-request-container">
      <div class="input-group">
        <textarea class="form-control cmessage-textarea" rows="1"
                  placeholder="Chiedi qualcosa"
                  [(ngModel)]="currentQuestion"
                  (keydown.enter)="$event.preventDefault(); sendAskQuestion(currentQuestion)"
        ></textarea>
        <button class="btn btn-outline-primary btn-send-question"
                (click)="sendAskQuestion(currentQuestion)"
                [disabled]="currentQuestion?.length < 2"
                type="button">
        </button>
      </div>
    </div>
    <div class="text-center text-muted pt-1" style="font-size: 10px;">
      Primatoo Bot può commettere errori. Considera di verificare le informazioni importanti.
    </div>
  </div>

  <!--  <div class="modal-footer">-->
  <!--      <button (click)="close()"-->
  <!--              data-testid="chatbot-close"-->
  <!--              class="btn btn-sm btn-outline-secondary">-->
  <!--        {{ "BUTTON.CLOSE" | translate }}-->
  <!--      </button>-->
  <!--  </div>-->
</ng-template>

